// import firebase from 'firebase/app'
// import 'firebase/auth'
// import 'firebase/firestore'
// import * as firebase from 'firebase'
// import '@firebase'
// import '@firebase/app'
// import '@firebase/auth'
// import '@firebase/firestore'

// import firebase from 'firebase'

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyAbR3p3ajbJ_2EtEmjy9z-NYdnb4LZhxDI",
  authDomain: "mania-de-eventos.firebaseapp.com",
  projectId: "mania-de-eventos",
  storageBucket: "mania-de-eventos.appspot.com",
  messagingSenderId: "254538360801",
  appId: "1:254538360801:web:2cf800bb5dbb2bb41054a0",
  measurementId: "G-TJF64HJ1FL"
};

const firebaseConfigTest = {
  apiKey: "AIzaSyBmkmM31VXibuWlpLN1esxyhMKGiF1TeQ0",
  authDomain: "mania-teste-43c77.firebaseapp.com",
  projectId: "mania-teste-43c77",
  storageBucket: "mania-teste-43c77.appspot.com",
  messagingSenderId: "897364603543",
  appId: "1:897364603543:web:c6bff4d63101d150902fd2"
};
  
// eslint-disable-next-line no-unused-vars

const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')

const firebaseApp = firebase.initializeApp(isDev ? firebaseConfigTest : firebaseConfig);
const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();
export { firebaseApp, db, storage, auth }
// export default db;

// // import firebase from 'firebase'
// // let firebase = require('firebase')

// import { initializeApp } from 'firebase/app'
// import { getFirestore } from 'firebase/firestore'
// // import * as firebase from 'firebase/app'
// // import '@firebase/auth'
// // import '@firebase/firestore'
// // import '@firebase/storage'

// // import * as firebase from 'firebase'
// // import firebase from 'firebase'
// // import 'firebase/auth'
// // import 'firebase/firestore'
// // import 'firebase/storage'

// // // import firebase from 'firebase'

// const firebaseConfig = {
//   apiKey: "AIzaSyAbR3p3ajbJ_2EtEmjy9z-NYdnb4LZhxDI",
//   authDomain: "mania-de-eventos.firebaseapp.com",
//   projectId: "mania-de-eventos",
//   storageBucket: "mania-de-eventos.appspot.com",
//   messagingSenderId: "254538360801",
//   appId: "1:254538360801:web:2cf800bb5dbb2bb41054a0",
//   measurementId: "G-TJF64HJ1FL"
// };

// // // if (!firebase.apps.length) {
// //   firebase.initializeApp(firebaseConfig)
// // // }

// // const firebaseApp=firebase.initializeApp(firebaseConfig);
// // const db=firebase.firestore();

// // export default db;

// const app = initializeApp(firebaseConfig)
// const db = getFirestore(app)
// export {app as firebase, db}

// // const app = firebase.initializeApp(firebaseConfig)
// // export default app
// // export default firebase
// // const app = initializeApp(firebaseConfig)
// // const db = getFirestore(app)
// // export default app
// // export {db}
